import type {
    ApplyCommerceCheckoutPointsRequest,
    ApplyCommerceCheckoutPointsResponse,
} from "@teqtank/commerce-contracts";
import type { CommerceOperation } from "@teqtank/commerce-transport";

export const applyCommerceCheckoutPointsOperation: CommerceOperation<
    ApplyCommerceCheckoutPointsRequest,
    ApplyCommerceCheckoutPointsResponse
> = Object.freeze({
    name: "commerce.checkout.points.apply",
});
